import React from 'react';
import { useDispatch } from 'react-redux';

import { sortFilter } from '../../../../../reducers/filtersSlice';
import { downArrowSVG } from '../../../../../../assets/svgIcons';

const SortInput = () => {
  const dispatch = useDispatch();

  const handleSelectChange = (event) => {
    const value = event.target.value;
    dispatch(sortFilter(value));
  };

  return (
    <div className='vesta-relative-position'>
      <div className='vesta-select-label'>
        <label htmlFor='standard-select' className='typo-bold-content vesta-margin-r-10 vesta-indigo-100'>
          Trier par
        </label>

        {downArrowSVG('#5076F6')}
      </div>

      <div className='vesta-select-container vesta-select-input'>
        <span className='focus'></span>

        <select id='standard-select' className='typo-caption vesta-indigo-50' onChange={handleSelectChange}>
          <option value='' defaultValue className='typo-caption'>
            Les plus récents
          </option>
          <option value='salePriceDesc'>Les plus chers</option>
          <option value='salePriceAsc'>Les moins chers</option>
          <option value='salePriceBySurfaceAsc'>Prix au m2 croissant</option>
        </select>
      </div>
    </div>
  )
};

export default SortInput;
